<template>
  <div class="container m-2">
    <h1 class="font-mono text-lg my-4">MS Azure AD B2C test page</h1>
    <div v-if="isAuthenticated">
      <h2>User Authenticated</h2>
      <div v-for="account in accounts">
        <p>Username: {{ account.username }}</p>
        <p>Name: {{ account.name }}</p>
        <p>Environment: {{ account.environment }}</p>
        <p>Home Account Id: {{ account.localAccountId }}</p>
        <p>Token: "{{ token }}"</p>

        <div class="mt-4">
          <AddButton @click="signOut()">Sign Out</AddButton>
          <AddButton @click="acquireToken()">Aquire Token</AddButton>
        </div>
      </div>
    </div>
    <div v-else>
      Not authenticated
      <AddButton v-if="!isAuthenticated" @click="signIn()">Sign In</AddButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import * as msal from "@azure/msal-browser";

const b2cName = "aksafetynet";
const policyName = "B2C_1_signup_signin";
const passwordResetPolicy = "B2C_1_reset_password";
const options = {
  clientId: "b71e37b8-c1e3-4963-b434-b3eb4247f3f3",
  loginAuthority: `https://${b2cName}.b2clogin.com/${b2cName}.onmicrosoft.com/${policyName}/`,
  passwordAuthority: `https://${b2cName}.b2clogin.com/${b2cName}.onmicrosoft.com/${passwordResetPolicy}/`,
  knownAuthority: [`${b2cName}.b2clogin.com`, "aksafetynet.onmicrosoft.com"],
  redirectUri: "https://jwt.ms",
};

var msalApp = {} as msal.PublicClientApplication;

onMounted(() => {
  initializeMsalApp();
});

let isAuthenticated = ref(false);
var accounts = ref<msal.AccountInfo[]>([]);
let token = ref("");

const config: msal.Configuration = {
  auth: {
    clientId: options.clientId,
    authority: options.loginAuthority,
    knownAuthorities: options.knownAuthority,
    redirectUri: "http://localhost:5000",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: msal.LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case msal.LogLevel.Error:
            console.error(message);
            return;
          case msal.LogLevel.Info:
            console.info(message);
            return;
          case msal.LogLevel.Verbose:
            console.debug(message);
            return;
          case msal.LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      piiLoggingEnabled: false,
      logLevel: msal.LogLevel.Verbose,
    },
  },
};

async function signIn() {
  try {
    const loginRequest: msal.PopupRequest = {
      redirectUri: "http://localhost:5000",
      scopes: ["openid", "offline_access"],
      extraScopesToConsent: ["https://aksafetynet.onmicrosoft.com/api/vr_access"],
    };
    const loginResponse: msal.AuthenticationResult = await msalApp.loginPopup(loginRequest);
    console.log(`Login successful`, loginResponse);
    accounts.value = [loginResponse.account];
    isAuthenticated.value = !!loginResponse.account;
    // do something with this?
  } catch (err: any) {
    // handle error
    if (err.errorMessage && err.errorMessage.indexOf("AADB2C90118") > -1) {
      //   try {
      //     const passwordResetResponse: msal.AuthenticationResult = await msalApp.loginPopup({
      //       scopes: ["openid", "offline_access", , "api_access"],
      //       authority: options.passwordAuthority,
      //     });
      //     isAuthenticated.value = !!passwordResetResponse.account;
      //   } catch (passwordResetError) {
      //     console.error(passwordResetError);
      //   }
    } else {
      console.warn(err.errorMessage);
      isAuthenticated.value = false;
    }
  }
}

async function signOut() {
  await msalApp.logoutPopup();
  isAuthenticated.value = false;
}

async function acquireToken() {
  const request: msal.SilentRequest = {
    account: msalApp.getAllAccounts()[0],
    scopes: ["https://aksafetynet.onmicrosoft.com/api/vr_access"],
    authority: `${b2cName}.b2clogin.com`,
  };
  try {
    const response = await msalApp.acquireTokenSilent(request);
    //const response = await msalApp.acquireTokenPopup(request);
    token.value = response.accessToken;
    console.log(`Got token: '${response.accessToken}'`);
  } catch (error) {
    console.warn("Error getting token silently", error);

    // if (error instanceof msal.InteractionRequiredAuthError) {
    //   return msalApp.acquireTokenPopup(request).catch((popupError) => {
    //     console.error("Error getting token with popup", popupError);
    //   });
    // }
    return false;
  }
}

function initializeMsalApp() {
  msalApp = new msal.PublicClientApplication(config);
  accounts.value = msalApp.getAllAccounts();
  isAuthenticated.value = accounts.value && accounts.value.length > 0;
}
</script>
